// /src/engine/snap.ts

import * as THREE from 'three';
import type { EditorMode, SnapSettings } from '@/store/modelStore';

export function snapValue(v: number, step: number): number {
  if (step <= 0) return v;
  return Math.round(v / step) * step;
}

export function snapEuler(e: THREE.Euler, degStep: number, mode: EditorMode) {
  const step = THREE.MathUtils.degToRad(degStep);
  if (!Number.isFinite(step) || step <= 0) return;

  // Beginner default: snap only around Y (turntable feel)
  if (mode === 'beginner') {
    e.y = Math.round(e.y / step) * step;
    return;
  }

  // Advanced: snap all axes
  e.x = Math.round(e.x / step) * step;
  e.y = Math.round(e.y / step) * step;
  e.z = Math.round(e.z / step) * step;
}

export function applySnapToObject(obj: THREE.Object3D, settings: SnapSettings, mode: EditorMode) {
  if (!settings.enabled) return;
  if (settings.gridSnap) {
    obj.position.x = snapValue(obj.position.x, settings.grid);
    obj.position.z = snapValue(obj.position.z, settings.grid);
  }
  if (settings.heightSnap) {
    obj.position.y = snapValue(obj.position.y, settings.height);
  }
  if (settings.rotSnap) {
    snapEuler(obj.rotation, settings.rotDeg, mode);
  }
  obj.updateMatrix();
}
